// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "DAI",
    token: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE",
    variableDebtTokenAddress: "0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC",
  },
  {
    symbol: "LINK",
    token: "0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530",
    variableDebtTokenAddress: "0x953A573793604aF8d41F306FEb8274190dB4aE0e",
  },
  {
    symbol: "USDC.e",
    token: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x625E7708f30cA75bfd92586e17077590C60eb4cD",
    variableDebtTokenAddress: "0xFCCf3cAbbe80101232d343252614b6A3eE81C989",
  },
  {
    symbol: "WBTC",
    token: "0x68f180fcCe6836688e9084f035309E29Bf0A2095",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x078f358208685046a11C85e8ad32895DED33A249",
    variableDebtTokenAddress: "0x92b42c66840C7AD907b4BF74879FF3eF7c529473",
  },
  {
    symbol: "WETH",
    token: "0x4200000000000000000000000000000000000006",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8",
    variableDebtTokenAddress: "0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351",
  },
  {
    symbol: "USDT",
    token: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x6ab707Aca953eDAeFBc4fD23bA73294241490620",
    variableDebtTokenAddress: "0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7",
  },
  {
    symbol: "AAVE",
    token: "0x76FB31fb4af56892A25e32cFC43De717950c9278",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xf329e36C7bF6E5E86ce2150875a84Ce77f477375",
    variableDebtTokenAddress: "0xE80761Ea617F66F96274eA5e8c37f03960ecC679",
  },
  {
    symbol: "sUSD",
    token: "0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97",
    variableDebtTokenAddress: "0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8",
  },
  {
    symbol: "OP",
    token: "0x4200000000000000000000000000000000000042",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf",
    variableDebtTokenAddress: "0x77CA01483f379E58174739308945f044e1a764dc",
  },
  {
    symbol: "wstETH",
    token: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA",
    variableDebtTokenAddress: "0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907",
  },
  {
    symbol: "LUSD",
    token: "0xc40F949F8a4e094D1b49a23ea9241D289B7b2819",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x8Eb270e296023E9D92081fdF967dDd7878724424",
    variableDebtTokenAddress: "0xCE186F6Cccb0c955445bb9d10C59caE488Fea559",
  },
  {
    symbol: "MAI",
    token: "0xdFA46478F9e5EA86d57387849598dbFB2e964b02",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x8ffDf2DE812095b1D19CB146E4c004587C0A0692",
    variableDebtTokenAddress: "0xA8669021776Bc142DfcA87c21b4A52595bCbB40a",
  },
  {
    symbol: "rETH",
    token: "0x9Bcef72be871e61ED4fBbc7630889beE758eb81D",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x724dc807b04555b71ed48a6896b6F41593b8C637",
    variableDebtTokenAddress: "0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6",
  },
  {
    symbol: "USDC",
    token: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5",
    variableDebtTokenAddress: "0x5D557B07776D12967914379C71a1310e917C7555",
  },
] as const
